import { Injectable } from '@angular/core';
import { DataProvider } from '../../providers/data.provider';
import { Settings } from '../../app.settings';
import { Observable } from 'rxjs';

@Injectable()
export class ContactProvider {
  constructor(private dataProvider: DataProvider, private settings: Settings) {

  }

  public contactUsAsync(data: any) {
    return this.dataProvider.getData(`Items/GetActiveAndArchivedItemsByWebsiteByCategoryByCount/${this.settings.websiteId}/8/100`);
  }

  public sendContactUsAsync = (dataUrl: string, contactUsData: any): Observable<Response> => {
    const contactUsDataJson = JSON.stringify(contactUsData);

    const emailSettings = {
      ToList: this.settings.emailTo,
      From: this.settings.emailFrom,
      Subject: 'Contact Us Form',
      TemplateName: 'ContactUsTemplate',
      TemplateModel: contactUsDataJson,
      WebsiteId: this.settings.websiteId,
      IpAddress: 'N/A'
    };

    return this.dataProvider.postData(dataUrl, emailSettings);
  }
}
